module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.963eb329.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OpenSans-Light.woff
// module id = 1835
// module chunks = 0